export default __webpack_public_path__ + "static/media/optimization-square-bracket-right.120e9a2f.svg";